module.exports = __webpack_public_path__ + "img/UTGUNL-1.0749bba0.jpg";